import React from "react";

function Header() {
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-primary mb-4">
      <div className="container-fluid d-flex justify-content-between">
        <div className="container py-3">
          <a className="navbar-brand" href="/">
            placement constructor
          </a>
        </div>
      </div>
    </nav>
  );
}

export default Header;
